const isHeFetchError = (error) => error?.errorData !== undefined || typeof error?.code === 'number';

export const getApiErrorStatus = (error) => (isHeFetchError(error) ? error.code : error?.status) ?? null;

export const getApiErrorBody = (error) => {
    if (!error) {
        return null;
    }
    if (isHeFetchError(error)) {
        return error.errorData?.message ?? null;
    }
    if (error.responseJSON !== undefined) {
        return error.responseJSON;
    }
    if (typeof error.responseText === 'string') {
        try {
            return JSON.parse(error.responseText);
        } catch {
            return error.responseText;
        }
    }
    return null;
};

export const getApiErrorText = (error) => {
    const body = getApiErrorBody(error);
    if (body === null || body === undefined) {
        return '';
    }
    return typeof body === 'string' ? body : JSON.stringify(body);
};
